import { ReactElement } from 'react';
import styles from './DotNetixNameTooltip.module.scss';
import { CustomTooltipProps } from 'ag-grid-react';
import { useTranslation } from 'react-i18next';
import { DotNetixRemoteObjectModel } from '@customer/store/apis/interactionsApi';

// Don't return a tooltip if the asset name is not DotNetix
export const DotNetixNameTooltip = ({
  value,
}: CustomTooltipProps<DotNetixRemoteObjectModel, boolean>): ReactElement | null => {
  const { t } = useTranslation();

  if (value) {
    return <div className={styles.tooltip}>{t('ObjectDetectionTooltip')}</div>;
  } else {
    return null;
  }
};

export default DotNetixNameTooltip;
